import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PublicRoute = ({ children, ...rest }) => {
    return (
        <Route {...rest} children={() => {
            return localStorage.getItem('profile') ? <Redirect to='/' /> : children
        }} />
    )
}

export default PublicRoute
